import { ComponentProps } from 'react';
import { Modal, ModalContent, ModalTitle } from '../../../../design-system/modal/modal';
import { Stack } from '../../../../design-system/stack/stack';
import { CategoryView } from '../../../../types/entity-types';
import { DuplicateVendorCard } from './duplicate-vendor-card';
import { EditVendorForm } from './edit-vendor-form';

type EditVendorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  showCategorySelect?: boolean;
  category?: CategoryView;
  categories: CategoryView[];
  description?: string | null;
  isDuplicateName: boolean;
  isLoading: boolean;
  onSubmit: ComponentProps<typeof EditVendorForm>['onSubmit'];
};

export const EditVendorModal = ({ isOpen, onClose, ...props }: EditVendorModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-[414-px] w-[520px] bg-white px-7 py-6">
        <Stack space={3} className="px-1">
          <ModalTitle>Edit Vendor</ModalTitle>

          {props.isDuplicateName && <DuplicateVendorCard />}
        </Stack>

        <EditVendorForm {...props} onCancel={onClose} />
      </ModalContent>
    </Modal>
  );
};
